import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import { LoginPage } from "./pages/auth/LogInPage";
import { HomePage } from "./pages/homePage/HomePage";
import {
  checkAuthLoader,
  DashBoardPage,
} from "./pages/dashboard/DashBoardPage";
import { CategoryPage } from "./pages/category/CategoryPage";
import { ErrorPage } from "./pages/error/ErrorPage";
import { RootLayout } from "./pages/RootLayout";
import { AdvertisementPage } from "./pages/advertisement/AdvertisementPage";
import { MastersPage } from "./pages/master/MastersPage";
import { MasterVrpPage } from "./pages/master/masterVrp/MasterVrpPage";
import { MastersVariantPage } from "./pages/master/masterVariant/MastersVariantPage";
import { MastersCategoryPage } from "./pages/master/mastersCategoryPage/MastersCategoryPage";
import { RetailerPage } from "./pages/retailer/RetailerPage";
import { OrderPage } from "./pages/order/OrderPage";
import { CouponPage } from "./pages/coupon/CouponPage";
import { FormFieldArray } from "./component/dynamicForm/formFieldArray/FormFieldArray";
import { CancellationPage } from "./pages/cancellation/CancellationPage";
import { RefundPage } from "./pages/refund/RefundPage";
import { ProductListPage } from "./pages/category/productList/ProductListPage";
import { ProductDetailPage } from "./pages/category/productDetail/ProductDetailPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    loader: checkAuthLoader,
    children: [
      {
        path: "/",
        element: <DashBoardPage />,

        children: [
          { index: true, element: <HomePage /> },
         {
        path: ":category",
        children: [
          { index: true, element: <CategoryPage /> },
          { path: ":inventory_id", element: <ProductListPage /> },
          { path: ":inventory_id/:productId", element: <ProductDetailPage /> },
        ],
      },
          { path: "advertisement", element: <AdvertisementPage /> },
          { path: "coupon", element: <CouponPage /> },
          { path: "specs", element: <FormFieldArray /> },

          {
            path: "masters",
            element: <MastersPage />,
            children: [
              { path: "vrp", element: <MasterVrpPage /> },
              {
                path: ":category",
                element: <MastersCategoryPage />,
              },
              { path: ":category/variants", element: <MastersVariantPage /> },
            ],
          },

          { path: "retailers", element: <RetailerPage /> },
          { path: "orders", element: <OrderPage /> },
          { path: "cancellation", element: <CancellationPage /> },
          { path: "refund", element: <RefundPage /> },
        ],
      },
    ],
  },
  { path: "login", element: <LoginPage /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
